function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M97.0537 97.9017C93.717 95.9752 92.5737 91.7085 94.5002 88.3718C96.4267 85.035 100.693 83.8917 104.03 85.8182C107.367 87.7447 108.51 92.0114 106.584 95.3482C104.657 98.6849 100.39 99.8282 97.0537 97.9017Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M104.03 74.1818C100.693 76.1083 96.4267 74.965 94.5002 71.6282C92.5738 68.2915 93.717 64.0248 97.0538 62.0983C100.391 60.1718 104.657 61.3151 106.584 64.6518C108.51 67.9886 107.367 72.2553 104.03 74.1818Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M80 110.696C83.8529 110.696 86.9764 107.573 86.9764 103.72C86.9764 99.8668 83.8529 96.7434 80 96.7434C76.147 96.7434 73.0235 99.8668 73.0235 103.72C73.0235 107.573 76.147 110.696 80 110.696Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M86.9764 80C86.9764 83.853 83.8529 86.9764 80 86.9764C76.147 86.9764 73.0235 83.853 73.0235 80C73.0235 76.147 76.147 73.0236 80 73.0236C83.8529 73.0236 86.9764 76.147 86.9764 80Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M86.9764 56.2802C86.9764 60.1332 83.8529 63.2566 80 63.2566C76.147 63.2566 73.0235 60.1332 73.0235 56.2802C73.0235 52.4272 76.147 49.3038 80 49.3038C83.8529 49.3038 86.9764 52.4272 86.9764 56.2802Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M53.4162 95.3482C55.3427 98.685 59.6094 99.8282 62.9461 97.9018C66.2829 95.9753 67.4262 91.7086 65.4997 88.3718C63.5732 85.035 59.3065 83.8918 55.9697 85.8183C52.633 87.7447 51.4897 92.0115 53.4162 95.3482Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M53.4162 64.6519C51.4897 67.9887 52.633 72.2554 55.9698 74.1819C59.3065 76.1084 63.5732 74.9651 65.4997 71.6284C67.4262 68.2916 66.2829 64.0249 62.9462 62.0984C59.6094 60.1719 55.3427 61.3152 53.4162 64.6519Z",
  fill: "white"
});

function SvgCoinIconDot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIconDot);
export default __webpack_public_path__ + "static/media/CoinIconDOT.90e205ba.svg";
export { ForwardRef as ReactComponent };